import { inject, Injectable, NgZone } from '@angular/core';
import { Settings } from '../settings/settings.service';
import { MatrixService } from '../matrix/matrix.service';

@Injectable({
  providedIn: 'root'
})
/**
 * Angular-Service um die Inaktivität eines Users zu tracken.
 *
 * Dieser Service trackt die Inaktivität eines User und loggt diesen bei Ablauf der Inaktivitätsfrist aus.
 *
 * Hierdurch erfüllte AFO's:
 *
 * A_25507 - Abmeldung statt Sperre bei Web-Clients
 * A_26282 - Automatische Abmeldung bei geschlossenem Client
 */
export class InactivityService {
  private timeout: ReturnType<typeof setTimeout> | undefined;
  private readonly clientService = inject(MatrixService);
  private readonly ngZone = inject(NgZone);

  public startWatching(): void {
    this.ngZone.runOutsideAngular(() => {
      this.resetTimer();
      document.addEventListener('mousemove', () => this.resetTimer());
      document.addEventListener('keydown', () => this.resetTimer());
      document.addEventListener('click', () => this.resetTimer());
      document.addEventListener('scroll', () => this.resetTimer());
    });
  }

  private resetTimer(): void {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      // Cleanup und IDP-Abmeldung wie beim manuellen Logout: Der lokale Cleanup darf die
      // Weiterleitung zur Keycloak-Logout-Seite nicht verhindern, und die Weiterleitung muss
      // die IDP-Session (SSO-Cookie) tatsächlich beenden. Eine reine Navigation zur
      // App-internen /login-Route würde das SSO-Cookie bestehen lassen und den User sofort
      // wieder ohne Passwort einloggen (verletzt A_25507/A_26282).
      try {
        await this.clientService.logout();
      } catch (error) {
        console.warn(
          'matrix.logout() bei Inaktivitäts-Abmeldung fehlgeschlagen — leite trotzdem zur IDP-Logout-Seite weiter:',
          error
        );
      }
      this.clientService.redirectToIdpLogout();
    }, Settings.getInstance().settingsConfigurations.inactivity);
  }
}
